<script setup>
import { ref, onMounted } from 'vue';

// Reactive state to store the service providers
const serviceProviders = ref([]);

// Fetch service providers when the component is mounted
onMounted(async () => {
  try {
    const response = await fetch('/api/service-providers'); // Replace with your actual API endpoint
    if (response.ok) {
      serviceProviders.value = await response.json();
    } else {
      console.error('Failed to fetch service providers:', response.statusText);
    }
  } catch (error) {
    console.error('Error fetching service providers:', error);
  }
});
</script>

<template>
  <div class="page-title">
    <div class="col-md-12 project-list">
      <div class="card">
        <div class="row">
          <div class="col-sm-6">
            <h3>Service Provider Overview</h3>
          </div>
          <div class="col-sm-6 d-md-block">
            <a class="btn btn-primary align-items-center" href="/admin/service-provider/new">
              <i class="fa-regular fa-square-plus"></i>
              Add Service Provider
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Loop through each service provider and display them -->
      <div v-for="provider in serviceProviders" :key="provider.id" class="col-sm-6 xl-50">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <img class="img-70 img-fluid m-r-20" :src="`/api/service-provider/${provider.id}/logo`" alt="">
              <div class="flex-grow-1 w-100">
                <!-- Link to service provider detail page (use the actual route and ID) -->
                <h5 class="f-w-700">
                  <a class="text-primary" :href="`/admin/service-provider/${provider.id}`">{{ provider.name }}</a>
                </h5>
                <span class="badge badge-light-success">{{ provider.status || 'Active' }}</span>
              </div>
            </div>

            <div style="margin-top: 8px">
              <ul>
                <li class="d-flex align-items-center gap-2">
                  <div class="flex-grow-1">
                    <h6>Available Drivers</h6>
                  </div>
                  <div class="recent-text">
                    <!-- Display the number of drivers -->
                    <h5>{{ provider.availableDrivers || '0' }}</h5>
                  </div>
                </li>
                <hr>
                <li class="d-flex align-items-center gap-2">
                  <div class="flex-grow-1">
                    <h6>Total Rides</h6>
                  </div>
                  <div class="recent-text">
                    <!-- Display the total rides -->
                    <h5>{{ provider.totalRides || '0' }}</h5>
                  </div>
                </li>
                <hr>
                <li class="d-flex align-items-center gap-2">
                  <div class="flex-grow-1">
                    <h6>Other Statistic</h6>
                  </div>
                  <div class="recent-text">
                    <!-- Display any other statistics if necessary -->
                    <h5>{{ provider.otherStatistic || 'N/A' }}</h5>
                  </div>
                </li>
              </ul>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>